import { Component, Input } from '@angular/core';
import { HrFormButtonEvents } from '../../base-form/hr-form-button-events';
import { HrTranslateKey } from '../../translate/hr-translate-key';

@Component({
    selector: 'hr-form-buttons',
    templateUrl: './hr-form-buttons.component.html',
})
export class HrFormButtonsComponent {
    @Input() showSave: boolean;
    @Input() idPrefix: string;
    @Input() showDelete: boolean;
    @Input() form: HrFormButtonEvents;

    public onCancel() {
        this.form.onCancel();
    }

    public onSave() {
        this.form.onSave();
    }

    onRemove() {
        this.form.onRemove();
    }

    public get hrKey(): typeof HrTranslateKey {
        return HrTranslateKey;
    }
}
